import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { DamImage } from "@/utils/dam.utils";

type EveryDayLowPriceImageProps = {
    className?: string;
};

const EveryDayLowPriceImage = ({ className }: EveryDayLowPriceImageProps) => {
    const { t } = useGranite();

    return (
        <img
            className={cn("tw:h-22.5 tw:w-22.5", className)}
            src={DamImage.product.everydayLowPrice}
            alt={t("promotionLabel.everydaylowprice")}
        />
    );
};

export { EveryDayLowPriceImage };
